import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//===--- Main
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Account(props) {
  const [formData, setFormData] = useState({
      firstname: ""
  })
  function handleChange(event) { 
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [event.target.name]: event.target.value
        }
    })
  }
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      props.setSignedIn(true);
      navigate('/rewards');
    }

    setValidated(true);
  };

  return (
    <section id='account'>
      <h2>Log in</h2>
      <p>Sign up now to earn points on every order, get access to member exclusive perks, and <a href='#/rewards'>more</a></p>
      <Container className='bg-body-tertiary rounded'>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group as={Col} className='form-group' controlId="validationCustom01">
              <FloatingLabel controlId="floatingInput" label="Username or email address">
                <Form.Control
                  required
                  type="text"
                  placeholder="Username"
                  value={formData.firstname}
                  onChange={handleChange}
                  name='firstname'
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type='invalid'>Enter your email address</Form.Control.Feedback>
              </FloatingLabel>
              <Form.Text id="passwordHelpBlock" muted><a href='username_help'>Forgot your username?</a></Form.Text>
            </Form.Group>
            <Form.Group as={Col} className='form-group' controlId="validationCustom02">
              <FloatingLabel controlId="floatingPassword" label="Password">
                <Form.Control
                  required
                  type="password"
                  placeholder="Password"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type='invalid'>Enter a password</Form.Control.Feedback>
              </FloatingLabel>
              <Form.Text id="passwordHelpBlock" muted><a href='password_help'>Forgot your password?</a></Form.Text>
            </Form.Group>
            <Col className='form-submit'>
              <Form.Group className='mb-3'>
                <Form.Check
                    label='Keep me signed in'
                  />
              </Form.Group>
            </Col>
            <Button type='outline-dark submit' variant='dark'>Sign Up</Button>
        </Form>
      </Container>
      <p>Don't have an account? <a href='#/create_account'>Sign in</a></p>
    </section>
  );
}